import { useEffect, useState } from 'react';
import debounce from '../utils/debounce';

export type Devices = 'desktop' | 'tablet' | 'mobile';

const getDeviceByBreakpoint = (mobileBreakpoint?: number, tabletBreakpoint?: number): Devices => {
    if (window.innerWidth < (mobileBreakpoint || 767)) {
        return 'mobile';
    }
    if (window.innerWidth >= (mobileBreakpoint || 767) && window.innerWidth < (tabletBreakpoint || 991)) {
        return 'tablet';
    }

    return 'desktop';
};

const useDevice = (mobileBreakpoint?: number, tabletBreakpoint?: number) => {
    const [device, setDevice] = useState<Devices>(getDeviceByBreakpoint(mobileBreakpoint, tabletBreakpoint));

    const observeScreenWidth = () => {
        setDevice(getDeviceByBreakpoint(mobileBreakpoint, tabletBreakpoint));
    };

    useEffect(() => {
        const resizer = debounce(observeScreenWidth, 100);

        window.addEventListener('resize', resizer);

        return () => {
            window.removeEventListener('resize', resizer);
        };
    }, []);

    return device;
};

export default useDevice;
